import { useContext } from 'react';
import { HostInfoContext, HostInfoContextValue } from 'components/host-info-provider/host-info.context';
import { isDesktopHost } from 'shared/consts';

export const useHostInfo = (): HostInfoContextValue => useContext(HostInfoContext);

/**
 * Whether this view should draw its own back/close chrome, rather than leaning on the native header.
 * Wraps the context so a page never has to remember which platforms count as desktop.
 */
export const useIsDesktopHost = (): boolean => isDesktopHost(useHostInfo().hostPlatform);
